import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { blackUser } from "@/assets";
import { Link } from "react-router-dom";

function RoadmapTable({ data, selectedDate }) {
  return (
    <Table className="w-full">
      <TableHeader>
        <TableRow>
          <TableHead className="w-[100px]">ID</TableHead>
          <TableHead>Name</TableHead>
          <TableHead>Designations</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Time Sheet</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data && data?.length > 0 ? (
          data?.map((item, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">
                {item?.staff_id || item?.unique_id || item?.id || "N/A"}
              </TableCell>
              <TableCell>
                <div className="flex items-center gap-2">
                  <img
                    src={item?.file_manager_url || blackUser}
                    alt={item?.name}
                    className="w-8 h-8 rounded-full"
                  />
                  <span>{item?.name || "N/A"}</span>
                </div>
              </TableCell>
              <TableCell>{item?.designation || "N/A"}</TableCell>
              <TableCell
                className={`capitalize font-medium ${
                  item?.status?.toLowerCase() === "present"
                    ? "text-cgreen"
                    : "text-cred"
                }`}
              >
                {item?.status || "N/A"}
              </TableCell>
              <TableCell>
                <span className="text-right flex items-center justify-end">
                  <Link
                    className="text-cyellow hover:underline font-medium"
                    to={`/backoffice/staff-management/time-sheet-schedule/${item?.id}`}
                  >
                    Details
                  </Link>
                </span>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={5} className="text-center">
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}

export default RoadmapTable;
